import _Vue from "vue";
import UiNotificationComponent from "./ui-notification.vue";
import NotificationOptions, {
  EnumNotificationType
} from "./model/notificationOptions";

export default class Notification {
  private mounted = false;
  private $root: UiNotificationComponent;
  constructor() {}

  success(message: string, title = ""): void {
    this.open(
      new NotificationOptions(title, message, EnumNotificationType.Success)
    );
  }
  error(message: string, title = "Ошибка"): void {
    this.open(
      new NotificationOptions(title, message, EnumNotificationType.Error)
    );
  }
  private open(data: NotificationOptions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.mountIfNotMounted();
      (this.$root as any).show(data);
      (this.$root as _Vue).$once("change", (res: any) => {
        resolve(res);
      });
    });
  }
  private mountIfNotMounted() {
    if (this.mounted === true) {
      return;
    }
    let NotificationConstructor = _Vue.extend(UiNotificationComponent);
    this.$root = new NotificationConstructor();
    let node = document.createElement("div");
    document.querySelector("body").appendChild(node);
    this.$root.$mount(node);
    this.mounted = true;
  }
}
